import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import type { ChatPanelQuickActionsProps } from "./types";
import { springs } from "../motion";

export function ChatPanelQuickActions({ actions }: ChatPanelQuickActionsProps) {
  return (
    <div className="flex flex-col gap-1.5 px-5 py-3">
      {actions.map((action, index) => (
        <motion.button
          key={action.label}
          type="button"
          onClick={action.onClick}
          className="group flex items-center gap-2.5 w-full text-left rounded-xl px-3.5 py-2.5 text-[12.5px] font-medium text-secondary bg-white/60 border border-border/40 hover:border-accent/40 hover:bg-accent/5 hover:text-primary transition-all duration-200 cursor-pointer"
          initial={{ opacity: 0, x: -12 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ ...springs.smooth, delay: index * 0.06 }}
          aria-label={`Quick action: ${action.label}`}
        >
          <Sparkles
            size={13}
            className="text-accent/60 group-hover:text-accent transition-colors duration-200 shrink-0"
          />
          {action.label}
        </motion.button>
      ))}
    </div>
  );
}
